import React from "react";

const EditGridIcon = ({
  size = 24,
  color = "#0288D1",
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M14 4H10V8H14V4Z" fill={color} />
    <path d="M8 16H4V20H8V16Z" fill={color} />
    <path d="M8 10H4V14H8V10Z" fill={color} />
    <path d="M8 4H4V8H8V4Z" fill={color} />
    <path d="M14 12.42V10H10V14H12.42L14 12.42Z" fill={color} />
    <path
      d="M20.88 11.29L19.71 10.12C19.55 9.96 19.29 9.96 19.13 10.12L18.25 11L20 12.75L20.88 11.87C21.04 11.71 21.04 11.45 20.88 11.29Z"
      fill={color}
    />
    <path
      d="M11 18.25V20H12.75L19.42 13.33L17.67 11.58L11 18.25Z"
      fill={color}
    />
    <path d="M20 4H16V8H20V4Z" fill={color} />
  </svg>
);

export default EditGridIcon;
